import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import './CaseStudyDetail.css';
import { caseStudies } from '../data/site';

const CaseStudyDetail = () => {
  const { id } = useParams();
  const cs = caseStudies.find((c) => c.id === id);

  if (!cs) return <Navigate to="/case-studies" replace />;

  const related = caseStudies.filter((c) => c.id !== id).slice(0, 3);

  return (
    <div className="csd-page page-shell">
      <section className="csd-hero section-dark">
        <div className="site-container-wide csd-hero-grid">
          <div>
            <Link to="/case-studies" className="csd-back">← All case studies</Link>
            <span className="eyebrow-tag" >{cs.industry}</span>
            <h1>{cs.title}</h1>
            <p className="csd-summary">{cs.summary}</p>
            <div className="csd-meta">
              <div><span>Client</span><strong>{cs.client}</strong></div>
              <div><span>Region</span><strong>{cs.region}</strong></div>
              <div><span>Duration</span><strong>{cs.duration}</strong></div>
            </div>
          </div>
          <div className="hero-video-frame">
            <div className="frame-glow" />
            <img src={cs.image} alt={cs.title} />
            <span className="play-pill">CASE FILE</span>
          </div>
        </div>
      </section>

      <section className="csd-metrics-band">
        <div className="site-container-wide csd-metrics-grid">
          {cs.outcomes.map((o) => (
            <div className="csd-metric" key={o.label}>
              <strong>{o.value}</strong>
              <span>{o.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="site-container csd-body">
          <span className="section-eyebrow">Challenge</span>
          <h2>The starting point.</h2>
          <p>{cs.challenge}</p>

          <span className="section-eyebrow" style={{ marginTop: 30 }}>Solution</span>
          <h2>What we built.</h2>
          <p>{cs.solution}</p>

          <span className="section-eyebrow" style={{ marginTop: 30 }}>Approach</span>
          <h2>How we delivered.</h2>
          <ol className="csd-approach">
            {cs.approach.map((a, idx) => (
              <li key={a}><span>{String(idx + 1).padStart(2, '0')}</span><p>{a}</p></li>
            ))}
          </ol>

          <blockquote className="csd-quote">
            <p>{cs.quote}</p>
            <span>— {cs.quoteAuthor}</span>
          </blockquote>
        </div>
      </section>

      <section className="section csd-related section-dark">
        <div className="site-container-wide">
          <div className="section-head-row">
            <div>
              <span className="section-eyebrow">More outcomes</span>
              <h2 className="section-title">Related case studies.</h2>
            </div>
            <Link to="/case-studies" className="btn-ghost btn-arrow">All case studies</Link>
          </div>
          <div className="csd-related-grid">
            {related.map((r) => (
              <Link to={`/case-studies/${r.id}`} className="csd-related-card glass-card" key={r.id}>
                <img src={r.image} alt={r.title} />
                <div>
                  <span className="eyebrow-tag" >{r.industry}</span>
                  <h3>{r.title}</h3>
                  <strong>{r.metric}</strong>
                  <span className="csd-related-meta">{r.metricLabel}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="csd-cta">
        <div className="site-container-wide professional-card">
          <h2>Want a similar outcome?</h2>
          <p>Most engagements begin with a 30-minute discovery call.</p>
          <Link to="/request-demo" className="btn-primary-large">Book a consultation</Link>
        </div>
      </section>
    </div>
  );
};

export default CaseStudyDetail;
